import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Notifications from 'vue-notification'
import vClickOutside from 'v-click-outside'
import VuejsDialog from 'vuejs-dialog'
import moment from 'moment'
import { Datetime } from 'vue-datetime'
import { auth } from './services/firebase'
import AsyncComputed from 'vue-async-computed'

// external styles
import 'vue-datetime/dist/vue-datetime.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// const moment = require('moment')

Vue.use(require('vue-moment'), {
  moment,
})

Vue.config.productionTip = false

Vue.use(Notifications)
Vue.use(VuejsDialog)
Vue.use(vClickOutside)
Vue.use(Datetime)
Vue.use(AsyncComputed)

auth.onAuthStateChanged(async user => {
  if (user === null) store.dispatch('logoutUser', null)
  if (user && user.emailVerified === false) user.sendEmailVerification()
  await store.dispatch('fetchUserInformation', user)
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
